/* Cordelia Kraft — Gen Z uplift interactions (no dependencies). */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var moneyFormat = window.ckMoneyFormat || '${{amount}}';

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, v);
  }
  /* A form with an input named "id" shadows form.id, so read the attribute. */
  function formId(f) { return f.getAttribute('id'); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200); }

  function setCount(n) {
    document.querySelectorAll('[data-ck-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* ---------- toast (fallback when no drawer) ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.querySelector('.ck-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'ck-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = '<span></span><a href="' + root + 'cart">View bag</a>';
    t.firstChild.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 4000);
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('ck-cart-drawer');
  var lastFocus = null;
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var body = drawer.querySelector('[data-ck-drawer-body]');
    var foot = drawer.querySelector('[data-ck-drawer-foot]');
    drawer.querySelectorAll('[data-ck-drawer-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var goal = Number(drawer.getAttribute('data-goal') || 0);
    var bar = drawer.querySelector('[data-ck-goal]');
    if (bar && goal > 0) {
      var left = goal - cart.total_price;
      bar.querySelector('[data-ck-goal-text]').innerHTML = left > 0
        ? 'You’re <b>' + formatMoney(left) + '</b> away from ' + esc(bar.getAttribute('data-reward'))
        : 'Nice — you’ve unlocked ' + esc(bar.getAttribute('data-reward'));
      bar.querySelector('[data-ck-goal-fill]').style.width = Math.min(100, Math.round(cart.total_price / goal * 100)) + '%';
    }
    if (!cart.items.length) {
      body.innerHTML = '<div class="ck-drawer__empty"><p class="ck-display" style="font-size:44px">your bag is empty</p><p class="ck-muted">Let’s fix that.</p><a class="ck-btn" href="' + esc(drawer.getAttribute('data-empty-url')) + '">Shop best sellers</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' / ');
      return '<div class="ck-line">' +
        '<a href="' + esc(it.url) + '" class="ck-line__img">' + (it.image ? '<img src="' + esc(img(it.image, 240)) + '" alt="' + esc(it.product_title) + '" width="88" height="110" loading="lazy">' : '') + '</a>' +
        '<div class="ck-line__info"><a href="' + esc(it.url) + '" class="ck-line__title">' + esc(it.product_title) + '</a>' +
        (opts ? '<div class="ck-line__meta">' + opts + '</div>' : '') +
        '<div class="ck-line__row"><div class="ck-qty" role="group" aria-label="Quantity for ' + esc(it.product_title) + '">' +
        '<button type="button" data-ck-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-ck-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<b>' + formatMoney(it.final_line_price) + '</b></div>' +
        '<button type="button" class="ck-line__remove" data-ck-line="' + (i + 1) + '" data-qty="0">Remove</button></div></div>';
    }).join('');
    drawer.querySelector('[data-ck-subtotal]').textContent = formatMoney(cart.total_price);
  }
  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function openDrawer() {
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('ck-lock');
    var close = drawer.querySelector('[data-ck-drawer-close]');
    if (close) close.focus();
    return true;
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('ck-lock');
    setTimeout(function () { drawer.hidden = true; }, 280);
    if (lastFocus) lastFocus.focus();
  }
  if (drawer) {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ck-cart-open]');
      if (opener) { e.preventDefault(); fetchCart().then(renderCart); openDrawer(); return; }
      if (e.target.closest('[data-ck-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
      var lineBtn = e.target.closest('[data-ck-line]');
      if (lineBtn && drawer.contains(lineBtn)) {
        lineBtn.disabled = true;
        fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(lineBtn.getAttribute('data-ck-line')), quantity: Math.max(0, Number(lineBtn.getAttribute('data-qty'))) })
        }).then(function (r) { return r.json(); }).then(renderCart);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  }

  /* Open the bag instantly on click; fill it in when the add finishes. */
  function startAdding(title, image) {
    if (!drawer) return false;
    var body = drawer.querySelector('[data-ck-drawer-body]');
    var empty = body.querySelector('.ck-drawer__empty');
    if (empty) empty.remove();
    var old = body.querySelector('.ck-line--adding');
    if (old) old.remove();
    body.insertAdjacentHTML('afterbegin', '<div class="ck-line ck-line--adding" aria-live="polite">' +
      '<div class="ck-line__img">' + (image ? '<img src="' + esc(image) + '" alt="" width="88" height="110">' : '<span class="ck-skel" style="width:88px;height:110px;border-radius:10px"></span>') + '</div>' +
      '<div class="ck-line__info"><span class="ck-line__title">' + esc(title || 'Adding to your bag') + '</span>' +
      '<span class="ck-line__meta ck-adding">Adding to your bag</span><span class="ck-skel" style="width:120px;height:36px;border-radius:999px;margin-top:6px"></span></div></div>');
    drawer.querySelector('[data-ck-drawer-foot]').hidden = false;
    drawer.classList.add('is-adding');
    if (drawer.hidden || !drawer.classList.contains('is-open')) openDrawer();
    body.scrollTop = 0;
    return true;
  }
  function stopAdding(failed) {
    if (!drawer) return;
    drawer.classList.remove('is-adding');
    var l = drawer.querySelector('.ck-line--adding');
    if (l) l.remove();
    if (failed) fetchCart().then(renderCart);
  }
  function added(msg) {
    return fetchCart().then(function (cart) {
      renderCart(cart);
      stopAdding();
      if (!drawer) toast(msg);
    });
  }
  function failed(err) {
    stopAdding(true);
    if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    toast(err.message);
  }
  function cardInfo(el) {
    var card = el.closest('.ck-card, [data-ck-pdp], .ck-hero');
    if (!card) return {};
    var t = card.querySelector('.ck-card__title, .ck-buy__title, h1, h2, h3');
    var im = card.querySelector('img');
    return { title: t ? t.textContent.trim() : '', image: im ? (im.currentSrc || im.src) : '' };
  }
  /* Warm the drawer so it never shows "Loading" */
  if (drawer) {
    var warm = function () { fetchCart().then(renderCart).catch(function () {}); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1200);
  }
  function addToCart(id, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add'); return d; });
    });
  }

  /* ---------- quick add on cards ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ck-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    var info = cardInfo(btn);
    startAdding(info.title || btn.getAttribute('data-title'), info.image);
    addToCart(btn.getAttribute('data-ck-quick-add'), 1)
      .then(function () {
        btn.classList.add('is-added');
        btn.textContent = '✓';
        btn.setAttribute('aria-label', 'Added ' + (btn.getAttribute('data-title') || 'to bag'));
        return added('Added to your bag');
      })
      .catch(failed)
      .finally(function () { btn.disabled = false; });
  });

  /* ---------- filter chips (home grid) ---------- */
  document.querySelectorAll('[data-ck-filter-group]').forEach(function (group) {
    var grid = document.getElementById(group.getAttribute('data-ck-filter-group'));
    if (!grid) return;
    group.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-ck-filter]');
      if (!chip) return;
      var f = chip.getAttribute('data-ck-filter');
      group.querySelectorAll('[data-ck-filter]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      var shown = 0, max = Number(grid.getAttribute('data-max') || 8);
      grid.querySelectorAll('.ck-card').forEach(function (card) {
        var tags = (card.getAttribute('data-filters') || '').split(' ');
        var ok = f === 'all' || tags.indexOf(f) !== -1;
        if (ok && shown < max) { card.hidden = false; shown++; } else { card.hidden = true; }
      });
    });
  });

  /* ---------- auto-submit (collection sort / filters) ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-ck-autosubmit]');
    if (el && el.form) el.form.submit();
  });

  /* ---------- product forms (hero card + PDP) ---------- */
  document.querySelectorAll('form[data-ck-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qtyEl = form.querySelector('[name="quantity"]');
      var btns = document.querySelectorAll('[data-ck-atc="' + formId(form) + '"]');
      btns.forEach(function (b) { b.disabled = true; });
      var info = cardInfo(form);
      startAdding(info.title, info.image);
      addToCart(id, qtyEl ? Number(qtyEl.value) || 1 : 1)
        .then(function () { return added('Added to your bag'); })
        .catch(failed)
        .finally(function () { btns.forEach(function (b) { b.disabled = false; }); });
    });
  });

  /* ---------- PDP ---------- */
  var pdp = document.querySelector('[data-ck-pdp]');
  if (pdp) {
    var data = JSON.parse(pdp.querySelector('[data-ck-product-json]').textContent);
    var form = pdp.querySelector('form[data-ck-product-form]');
    var idInput = form.querySelector('[name="id"]');
    var heroOrig = null;
    var selected = function () {
      return Array.prototype.map.call(pdp.querySelectorAll('[data-ck-option-group]'), function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    };
    /* Show the variant's photo: swipe to it on mobile, swap it into the large first slot on desktop. */
    var showVariantMedia = function (index) {
      var items = pdp.querySelectorAll('.ck-gallery__item');
      var item = items[index];
      if (!item) return;
      if (window.matchMedia('(max-width: 989px)').matches) {
        item.parentNode.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        return;
      }
      var heroImg = items[0].querySelector('img');
      var srcImg = item.querySelector('img');
      if (!heroImg || !srcImg) return;
      if (!heroOrig) heroOrig = { src: heroImg.getAttribute('src'), srcset: heroImg.getAttribute('srcset'), alt: heroImg.getAttribute('alt') };
      var use = index === 0 ? heroOrig : { src: srcImg.getAttribute('src'), srcset: srcImg.getAttribute('srcset'), alt: srcImg.getAttribute('alt') };
      if (use.srcset) heroImg.setAttribute('srcset', use.srcset); else heroImg.removeAttribute('srcset');
      heroImg.setAttribute('src', use.src);
      heroImg.setAttribute('alt', use.alt || '');
      var top = items[0].getBoundingClientRect().top;
      if (top < 0) window.scrollBy({ top: top - 110, behavior: 'smooth' });
    };
    var update = function () {
      var sel = selected();
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); });
      if (!v) return;
      idInput.value = v.id;
      var price = formatMoney(v.price);
      pdp.querySelectorAll('[data-ck-price]').forEach(function (el) { el.textContent = price; });
      document.querySelectorAll('[data-ck-atc="' + formId(form) + '"]').forEach(function (b) {
        b.disabled = !v.available;
        var label = b.querySelector('[data-ck-atc-label]') || b;
        label.textContent = v.available ? (b.getAttribute('data-short') ? 'Add to bag' : 'Add to bag · ' + price) : 'Sold out';
      });
      if (v.featured_media_index != null) showVariantMedia(v.featured_media_index);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    };
    pdp.addEventListener('change', function (e) { if (e.target.closest('[data-ck-option-group]')) update(); });
    /* Opened from a variant link: show that variant's photo straight away. */
    if (/[?&]variant=/.test(window.location.search)) {
      var sel0 = selected();
      var v0 = data.variants.find(function (x) { return x.options.every(function (o, i) { return sel0[i] == null || o === sel0[i]; }); });
      if (v0 && v0.featured_media_index) showVariantMedia(v0.featured_media_index);
    }

    var gallery = pdp.querySelector('.ck-gallery');
    var dots = pdp.querySelectorAll('.ck-gallery__dots span');
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }, { passive: true });
    }

    var sticky = document.querySelector('.ck-sticky');
    var mainBtn = pdp.querySelector('.ck-atc-row');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(mainBtn);
    }

    var fav = pdp.querySelector('.ck-fav');
    if (fav) {
      var key = 'ck-fav-' + data.id;
      try { if (localStorage.getItem(key)) fav.setAttribute('aria-pressed', 'true'); } catch (e) {}
      fav.addEventListener('click', function () {
        var on = fav.getAttribute('aria-pressed') !== 'true';
        fav.setAttribute('aria-pressed', on ? 'true' : 'false');
        try { if (on) { localStorage.setItem(key, '1'); } else { localStorage.removeItem(key); } } catch (e) {}
        toast(on ? 'Saved to your wishlist' : 'Removed from wishlist');
      });
    }
  }
})();
